<template>
  <div class="row">

    <div class="col-lg-6">
      <!-- Country Select -->
      <div class="form__group">
        <div class="form-control form-control--select">
          <select
              id="locker_country_id"
              v-model="shipping.country_id"
              :disabled="inProgress"
              name="locker_country_id"
              @change="onSelectCountry"
          >
            <option :value="null" disabled selected>{{ in18['attribute_shipping_country_option'] }}</option>
            <option v-for="(country, index) in countries" :key="index" :value="country.id">
              {{ country.title }}
            </option>
          </select>
          <validation-error :errors="errors['shipping.country_id']"/>
        </div>
      </div><!-- End Country Select -->
    </div>

    <div class="col-lg-6">
      <TelFormField
          v-model="shipping.user_phone_number"
          name="mobile_phone_number"
          :id="'courier_mobile_phone_number'"
          :label="in18['attribute_user_phone']"
          :errors="phoneErrors"
          :in-progress="inProgress"
          @update:model-value="clearValidationError('shipping.user_phone_number.number');clearValidationError('shipping.user_phone_number.countryCallingCode')"
      />
    </div><!-- Phone -->

    <!-- Pickup Points Select (Hidden initially) -->
    <div class="form__group">
      <select
          id="locker_identifier_id"
          :disabled="inProgress"
          class="js-select2 d-none"
          name="locker_identifier_id"
      >
      </select>
      <validation-error :errors="errors['shipping.identifier']"/>
    </div><!-- End Pickup Points Select -->

    <!-- Message Textarea -->
    <div class="form__group">
    <textarea
        id="locker_message"
        v-model="shipping.message"
        :disabled="inProgress"
        :placeholder="in18['attribute_shipping_message_option']"
        class="form-control form-control--textarea"
        name="locker_message"
    ></textarea>
      <validation-error :errors="errors['shipping.message']"/>
    </div><!-- End Message Textarea -->

  </div><!-- .row -->
</template>

<script>
import ValidationError from '../../../features/ValidationError.vue';
import TelFormField from "../../form-field/TelFormField.vue";

export default {
  name:       "Locker",
  components: {
    TelFormField,
    ValidationError
  },
  emits:      [
    'update-cart',
    'country-selected',
    'update-in-progress',
    'update-error',
  ],
  props:      {
    shippingMethod: {
      type:     Object,
      required: true,
    },
    shipping:       {
      type:     Object,
      required: true,
    },
    errors:         {
      type:     Object,
      required: true,
    },
    in18:           {
      type: Object,
    },
    inProgress:     {
      type: Boolean,
    },
  },

  data() {
    return {
      countries: [],
      points:    [],
    };
  },

  created() {
    // Initialize available countries when the component is created
    this.getAvailableCountries();
  },

  mounted() {
    this.getPoints();
  },

  computed: {
    phoneErrors() {
      let errors = []
      if (this.errors['shipping.user_phone_number.number']) {
        errors = errors.concat(this.errors['shipping.user_phone_number.number'])
      }
      if (this.errors['shipping.user_phone_number.countryCallingCode']) {
        errors = errors.concat(this.errors['shipping.user_phone_number.countryCallingCode'])
      }
      return errors
    },
  },


  methods: {
    validateZipCode() {
      // Notify the parent component about the progress update
      this.$emit('update-in-progress', true);

      return axios.post(`/api/countries/${this.shippingMethod.id}/${this.shipping.country_id}/validate-zip-code`, {'shipping': this.shipping}).then((response) => {
        this.$emit('update-cart', response.data.cart);
        ga_add_shipping_info_event(response.data.cart);
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
        this.$emit('update-error', 'shipping.zip', error.response.data.errors['shipping.zip']);
      }).finally(() => {
        // Notify the parent component that the operation is complete
        this.$emit('update-in-progress', false);
      });
    },

    // Fetch available countries
    getAvailableCountries() {
      axios.get('/api/shipping/' + this.shippingMethod.id + '/countries').then((response) => {
        this.countries = response.data.countries;
      });
    },

    // Reset shipping data
    resetShippingData() {
      this.shipping.zip = '';
      this.shipping.city = '';
      this.shipping.address = '';
      this.shipping.identifier = null;

      this.points = [];
      $('#locker_identifier_id').empty();
    },

    // Handle country selection
    onSelectCountry() {
      this.resetShippingData();

      // Emit a custom event to notify the parent component
      this.$emit('country-selected', this.shippingMethod.id, this.shipping);

      // Fetch and populate pickup points based on the selected country
      this.getPoints();
    },

    clearValidationError(fieldName) {
      if (this.errors[fieldName]) {
        this.errors[fieldName] = null;
      }
    },

    // Fetch and populate pickup points based on the selected country
    getPoints() {
      let countryID = this.shipping.country_id;

      let locker_el = $('#locker_identifier_id');

      locker_el.off();

      locker_el.select2({
        placeholder: this.in18['attribute_shipping_locker_option'],
        width:       '100%',
        allowClear:  false,
        debug:       true,
        ajax:        {
          delay:          800,
          url:            '/api/shipping/' + this.shippingMethod.id + '/pickup-points',
          data:           function (params) {
            return {
              search:     params.term,
              country_id: countryID
            }
          },
          type:           'GET',
          dataType:       'json',
          processResults: function (response) {
            this.points = response.points; // Update the points array
            return {
              results: response.points.map(function (item) {
                return {
                  id:         item.id,
                  text:       item.full_address,
                  address:    item.address,
                  zip:        item.zip,
                  city:       item.city,
                  country_id: item.country_id,
                  identifier: item.identifier,
                };
              })
            };
          }.bind(this),
          cache:          true
        }
      }).on('select2:select', (e) => {

        // Update shipping data based on the selected pickup point
        this.shipping.zip = e.params.data.zip;
        this.shipping.city = e.params.data.city;
        this.shipping.address = e.params.data.address;
        this.shipping.country_id = e.params.data.country_id;
        this.shipping.identifier = e.params.data.identifier;

        // Call validateZipCode when the selection changes
        this.validateZipCode();
      });
    },
  },
};
</script>